module.exports = __webpack_public_path__ + "static/media/hetc_logo.bfaf1219.png";